export default "__VITE_ASSET__mt4Wdklm__"